import { render, staticRenderFns } from "./ProductDetailsCardMobile.vue?vue&type=template&id=18656290&scoped=true&"
import script from "./ProductDetailsCardMobile.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsCardMobile.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailsCardMobile.vue?vue&type=style&index=0&id=18656290&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18656290",
  null
  
)

export default component.exports